module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAVCAMAAACT1yXjAAAAPFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADQLyYwAAAAE3RSTlMAVa2oWtdNruvjg2ZDFw04NygnB/GIVwAAAFRJREFUGNPdylkOgCAQA9AyOuzgMve/q4BolCPwPtqkKSqtHhqdZyrElGCPRrtUS2ok156n3fBu2O0BZA74bAicQbzepDcTZBkJBKPJN0N/RhDVKF7jNARQRUdvVgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/envios.png
// module id = 488
// module chunks = 0